(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6156],{

/***/ 1304:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/tag/[tag]",
      function () {
        return __webpack_require__(9262);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_dom_server__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7762);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3726);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(striptags__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _storylinerlabs_design__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4468);
/* harmony import */ var next_mdx_remote__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3899);
/* harmony import */ var _layouts_BlogLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8862);
/* harmony import */ var _atoms_Column__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4992);
/* harmony import */ var _elements_NewsletterSection__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8108);
/* harmony import */ var _grids_PostsGrid__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3237);
/* harmony import */ var _meta_SEO__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8897);
/* harmony import */ var _atoms_Section__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9748);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8362);
// import node_modules








// import component






// import config

// define page
var BlogTagTemplate = function(param) {
    var blogTags = param.blogTags, blogPosts = param.blogPosts, blogTag = param.blogTag, hrefLang = param.hrefLang;
    // init render
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_meta_SEO__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                description: striptags__WEBPACK_IMPORTED_MODULE_3___default()(react_dom_server__WEBPACK_IMPORTED_MODULE_2__.renderToString(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_mdx_remote__WEBPACK_IMPORTED_MODULE_12__/* .MDXRemote */ .R, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, blogTag === null || blogTag === void 0 ? void 0 : blogTag.content)))),
                hrefLang: hrefLang,
                image: "".concat(_config__WEBPACK_IMPORTED_MODULE_11__/* .storylinerRootDomain */ .pk, "/img/screensavers/screensaver-break-creative-barriers-storyliner.jpg"),
                title: "".concat(blogTag === null || blogTag === void 0 ? void 0 : blogTag.title, " - Storyliner")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layouts_BlogLayout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                blogTags: blogTags,
                hrefLang: hrefLang,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_atoms_Section__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                        bgColor: "desertStorm",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_4__/* .Spacer */ .LZ, {
                                height: "64px"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_4__/* .Spacer */ .LZ, {
                                mobileHeight: "26px",
                                tabletHeight: "36px",
                                height: "56px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                        bgColor: "desertStorm",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_atoms_Column__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            cols: "lg",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6, {
                                    alignment: "center",
                                    tag: "h1",
                                    children: '<span class="has-marker">'.concat(blogTag === null || blogTag === void 0 ? void 0 : blogTag.title, "</span>")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                    alignment: "center",
                                    size: "large",
                                    children: react_dom_server__WEBPACK_IMPORTED_MODULE_2__.renderToString(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_mdx_remote__WEBPACK_IMPORTED_MODULE_12__/* .MDXRemote */ .R, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, blogTag === null || blogTag === void 0 ? void 0 : blogTag.content)))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                        bgColor: "desertStorm",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_4__/* .Spacer */ .LZ, {
                            mobileHeight: "25px",
                            tabletHeight: "25px",
                            height: "50px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_4__/* .Spacer */ .LZ, {
                            mobileHeight: "25px",
                            tabletHeight: "50px",
                            height: "50px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_grids_PostsGrid__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        bgColor: "white",
                        blogPosts: blogPosts
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_4__/* .Spacer */ .LZ, {
                            mobileHeight: "25px",
                            tabletHeight: "50px",
                            height: "75px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                        bgColor: "energyYellow",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_4__/* .Spacer */ .LZ, {
                            mobileHeight: "25px",
                            tabletHeight: "50px",
                            height: "75px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_NewsletterSection__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        bgColor: "energyYellow"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                        bgColor: "energyYellow",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_4__/* .Spacer */ .LZ, {
                            mobileHeight: "25px",
                            tabletHeight: "50px",
                            height: "75px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_4__/* .Spacer */ .LZ, {
                            height: "50px"
                        })
                    })
                ]
            })
        ]
    });
};
BlogTagTemplate.propTypes = {
    blogPosts: prop_types__WEBPACK_IMPORTED_MODULE_14__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_14__.shape({
        image: prop_types__WEBPACK_IMPORTED_MODULE_14__.string.isRequired,
        slug: prop_types__WEBPACK_IMPORTED_MODULE_14__.string.isRequired,
        tags: prop_types__WEBPACK_IMPORTED_MODULE_14__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_14__.string.isRequired).isRequired,
        title: prop_types__WEBPACK_IMPORTED_MODULE_14__.string.isRequired
    }).isRequired).isRequired,
    blogTag: prop_types__WEBPACK_IMPORTED_MODULE_14__.shape({
        content: prop_types__WEBPACK_IMPORTED_MODULE_14__.shape({
            compiledSource: prop_types__WEBPACK_IMPORTED_MODULE_14__.string.isRequired
        }).isRequired,
        slug: prop_types__WEBPACK_IMPORTED_MODULE_14__.string.isRequired,
        title: prop_types__WEBPACK_IMPORTED_MODULE_14__.string.isRequired
    }).isRequired,
    blogTags: prop_types__WEBPACK_IMPORTED_MODULE_14__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_14__.shape({
        slug: prop_types__WEBPACK_IMPORTED_MODULE_14__.string.isRequired,
        title: prop_types__WEBPACK_IMPORTED_MODULE_14__.string.isRequired
    }).isRequired).isRequired,
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_14__.string.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogTagTemplate);


/***/ }),

/***/ 9262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_templates_BlogTagTemplate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3810);
// import node_modules



// import component

// define page
var BlogTag = function(param) {
    var blogTag = param.blogTag, blogTags = param.blogTags, blogPosts = param.blogPosts, hrefLang = param.hrefLang;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_BlogTagTemplate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        blogTag: blogTag,
        blogTags: blogTags,
        blogPosts: blogPosts,
        hrefLang: hrefLang
    });
};
BlogTag.propTypes = {
    blogPosts: prop_types__WEBPACK_IMPORTED_MODULE_3__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_3__.shape({
        image: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
        slug: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
        tags: prop_types__WEBPACK_IMPORTED_MODULE_3__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired).isRequired,
        title: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired
    }).isRequired).isRequired,
    blogTag: prop_types__WEBPACK_IMPORTED_MODULE_3__.shape({
        content: prop_types__WEBPACK_IMPORTED_MODULE_3__.shape({
            compiledSource: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired
        }).isRequired,
        slug: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
        title: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired
    }).isRequired,
    blogTags: prop_types__WEBPACK_IMPORTED_MODULE_3__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_3__.shape({
        slug: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
        title: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired
    }).isRequired).isRequired,
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (BlogTag);


/***/ }),

/***/ 2746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Allow jsx-runtime to be successfully imported from either React 17 or React 18.
 *
 * Inspired by the approach here: https://github.com/contentlayerdev/contentlayer/blob/main/packages/next-contentlayer/src/hooks/jsx-runtime.cjs
 */
const jsxRuntime = __webpack_require__(5893)

module.exports.c = jsxRuntime


/***/ }),

/***/ 1151:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NF": function() { return /* binding */ withMDXComponents; },
/* harmony export */   "Zo": function() { return /* binding */ MDXProvider; },
/* harmony export */   "ah": function() { return /* binding */ useMDXComponents; },
/* harmony export */   "pC": function() { return /* binding */ MDXContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('mdx/types').MDXComponents} Components
 *
 * @typedef Props
 *   Configuration.
 * @property {Components} [components]
 *   Mapping of names for JSX components to React components.
 * @property {boolean} [disableParentContext=false]
 *   Turn off outer component context.
 * @property {ReactNode} [children]
 *   Children.
 *
 * @callback MergeComponents
 * @param {Components} currentComponents
 *   Current components from the context.
 * @returns {Components}
 *   Merged components.
 */



/**
 * @type {import('react').Context<Components>}
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components and
 *   `MDXProvider` to set context based components instead.
 */
const MDXContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({})

/**
 * @param {import('react').ComponentType<any>} Component
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components instead.
 */
function withMDXComponents(Component) {
  return boundMDXComponent

  /**
   * @param {Record<string, unknown> & {components?: Components}} props
   * @returns {JSX.Element}
   */
  function boundMDXComponent(props) {
    const allComponents = useMDXComponents(props.components)
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, {...props, allComponents})
  }
}

/**
 * Get current components from the MDX Context.
 *
 * @param {Components|MergeComponents} [components]
 *   Additional components to use or a function that takes the current
 *   components and filters/merges/changes them.
 * @returns {Components}
 *   Current components.
 */
function useMDXComponents(components) {
  const contextComponents = react__WEBPACK_IMPORTED_MODULE_0__.useContext(MDXContext)
  // Memoize to avoid unnecessary top-level context changes
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    // Custom merge via a function prop
    if (typeof components === 'function') {
      return components(contextComponents)
    }

    return {...contextComponents, ...components}
  }, [contextComponents, components])
}

/** @type {Components} */
const emptyObject = {}

/**
 * Provider for MDX context
 *
 * @param {Props} props
 * @returns {JSX.Element}
 */
function MDXProvider({components, children, disableParentContext}) {
  let allComponents = useMDXComponents(components)

  if (disableParentContext) {
    allComponents = components || emptyObject
  }

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    MDXContext.Provider,
    {value: allComponents},
    children
  )
}


/***/ }),

/***/ 3899:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ MDXRemote; }
});

// NAMESPACE OBJECT: ./node_modules/@mdx-js/react/index.js
var _mdx_js_react_namespaceObject = {};
__webpack_require__.r(_mdx_js_react_namespaceObject);
__webpack_require__.d(_mdx_js_react_namespaceObject, {
  "MDXContext": function() { return lib/* MDXContext */.pC; },
  "MDXProvider": function() { return lib/* MDXProvider */.Zo; },
  "useMDXComponents": function() { return lib/* useMDXComponents */.ah; },
  "withMDXComponents": function() { return lib/* withMDXComponents */.NF; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next-mdx-remote/dist/jsx-runtime.cjs
var jsx_runtime = __webpack_require__(2746);
// EXTERNAL MODULE: ./node_modules/@mdx-js/react/lib/index.js
var lib = __webpack_require__(1151);
;// CONCATENATED MODULE: ./node_modules/@mdx-js/react/index.js


;// CONCATENATED MODULE: ./node_modules/next-mdx-remote/dist/index.js




if (typeof window !== 'undefined') {
  window.requestIdleCallback =
    window.requestIdleCallback ||
    function (cb) {
      var start = Date.now();
      return setTimeout(function () {
        cb({
          didTimeout: false,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - start))
          },
        });
      }, 1)
    };

  window.cancelIdleCallback =
    window.cancelIdleCallback ||
    function (id) {
      clearTimeout(id);
    };
}

/**
 * Renders compiled source from next-mdx-remote/serialize.
 */
function MDXRemote({ compiledSource, frontmatter, scope, components = {}, lazy, }) {
    const [isReadyToRender, setIsReadyToRender] = (0,react.useState)(!lazy || typeof window === 'undefined');
    // if we're on the client side and `lazy` is set to true, we hydrate the
    // mdx content inside requestIdleCallback, allowing the page to get to
    // interactive quicker, but the mdx content to hydrate slower.
    (0,react.useEffect)(() => {
        if (lazy) {
            const handle = window.requestIdleCallback(() => {
                setIsReadyToRender(true);
            });
            return () => window.cancelIdleCallback(handle);
        }
    }, []);
    const Content = (0,react.useMemo)(() => {
        // if we're ready to render, we can assemble the component tree and let React do its thing
        // first we set up the scope which has to include the mdx custom
        // create element function as well as any components we're using
        const fullScope = Object.assign({ opts: { ..._mdx_js_react_namespaceObject, ...jsx_runtime/* jsxRuntime */.c } }, { frontmatter }, scope);
        const keys = Object.keys(fullScope);
        const values = Object.values(fullScope);
        // now we eval the source code using a function constructor
        // in order for this to work we need to have React, the mdx createElement,
        // and all our components in scope for the function, which is the case here
        // we pass the names (via keys) in as the function's args, and execute the
        // function with the actual values.
        const hydrateFn = Reflect.construct(Function, keys.concat(`${compiledSource}`));
        return hydrateFn.apply(hydrateFn, values).default;
    }, [scope, compiledSource]);
    if (!isReadyToRender) {
        // If we're not ready to render, return an empty div to preserve SSR'd markup
        return (react.createElement("div", { dangerouslySetInnerHTML: { __html: '' }, suppressHydrationWarning: true }));
    }
    // wrapping the content with MDXProvider will allow us to customize the standard
    // markdown components (such as "h1" or "a") with the "components" object
    const content = (react.createElement(lib/* MDXProvider */.Zo, { components: components },
        react.createElement(Content, null)));
    // If lazy = true, we need to render a wrapping div to preserve the same markup structure that was SSR'd
    return lazy ? react.createElement("div", null, content) : content;
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,4348,2539,675,7926,2457,2888,179], function() { return __webpack_exec__(1304); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);